import setupManager from './SetupManager'
import ObjectManager from './ObjectManager'
 
export default [...setupManager, ...ObjectManager]
